import { render, staticRenderFns } from "./BaseTableBody.vue?vue&type=template&id=be8af4ba"
import script from "./BaseTableBody.vue?vue&type=script&lang=js"
export * from "./BaseTableBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports